export default __webpack_public_path__ + "static/media/my-close-button.5ad8e7d5.png";